import React from 'react';
import { getTranslation } from '../utils/translations';
import './ProgressBar.css';

const ProgressBar = ({ currentStep, totalSteps, percentage, language = 'en' }) => {
  const circumference = 2 * Math.PI * 90; // radius of 90
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className="progress-bar-container">
      <div className="progress-bar-header">
        <span className="progress-text">{getTranslation('step', language)} {currentStep} {getTranslation('of', language)} {totalSteps}</span>
      </div>
      <div className="pie-chart-container">
        <svg className="pie-chart" width="200" height="200" viewBox="0 0 200 200">
          {/* Background circle */}
          <circle
            cx="100"
            cy="100"
            r="90"
            fill="none"
            stroke="#565869"
            strokeWidth="20"
          />
          {/* Progress circle */}
          <circle
            cx="100"
            cy="100"
            r="90"
            fill="none"
            stroke="url(#progressGradient)"
            strokeWidth="20"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            transform="rotate(-90 100 100)"
            className="progress-circle"
          />
          {/* Gradient definition */}
          <defs>
            <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#19c37d" />
              <stop offset="100%" stopColor="#4CAF50" />
            </linearGradient>
          </defs>
        </svg>
        <div className="pie-chart-center">
          <div className="pie-chart-percentage">{Math.round(percentage)}%</div>
          <div className="pie-chart-label">{getTranslation('progressComplete', language)}</div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;